import React from "react";

import {formattedDateTime} from "../../util/date";
import InitialsAvatar from "../../util/name_initial";

export default function OfficialAssignmentGameCard({
    event,
    index,
    colors,
    t,
    language,
    availableCount,
    pickerLabel,
    pickerIcon,
    selectedCount,
    pickerHint,
    details,
    children,
}) {
    const homeTeam = event.game?.homeTeam;
    const visitorTeam = event.game?.visitorTeam;
    const homeName = homeTeam?.name || event.game?.homeTeamAlias || t("officialAssignmentModal.labels.home");
    const visitorName = visitorTeam?.name || event.game?.visitorTeamAlias || t("officialAssignmentModal.labels.away");
    const location = [event.field?.name, event.address, event.city, event.state, event.country].filter(Boolean).join(" · ");
    const cardStyle = {border: "1px solid rgba(0,0,0,.08)", borderRadius: 14, padding: 16, background: "#fff", boxShadow: "0 8px 22px rgba(0,0,0,.05)"};

    const TeamBadge = ({team, name, alt, reverse = false}) => (
        <div className={`d-flex align-items-center official-assignment-team ${reverse ? "is-reversed" : ""}`} style={{minWidth: 0, flex: 1, gap: 10, ...(reverse ? {flexDirection: "row-reverse", textAlign: "right"} : {})}}>
            {team?.logoUrl ? <img className="kbola-teamLogo official-assignment-team-logo" width="46" height="46" src={team.logoUrl} alt={alt} style={{width: 46, height: 46, flex: "0 0 46px", objectFit: "contain", borderRadius: "50%", padding: 4, background: "#f5f7fa", border: "1px solid rgba(0,0,0,.08)"}} /> : <div className="kbola-avatarWrap"><InitialsAvatar name={name} size={46} backgroundColor={colors.primary} textColor={colors.textOnPrimary} /></div>}
            <span className="font-weight-bold text-truncate" title={name}>{name}</span>
        </div>
    );

    return (
        <div className="mb-3 official-assignment-card" style={cardStyle}>
            <div className="official-assignment-section-title">
                <span>{index + 1}</span>
                <div style={{minWidth: 0}}>
                    <div className="official-assignment-stage">
                        <span className="official-assignment-division">{event.season?.division?.name || "—"}</span>
                        <span>{event.stage?.name || t("officialAssignmentModal.labels.stagePool")}</span>
                        {event.game?.group?.name ? ` · ${event.game.group.name}` : ""}
                    </div>
                    <div className="official-assignment-game-number">{t("officialAssignmentModal.labels.gameNumber", {id: index + 1})}</div>
                </div>
                <span className="official-assignment-available" style={{color: colors.primary, background: `${colors.primary}12`, borderColor: `${colors.primary}30`}}>
                    <i className="fas fa-users mr-1" aria-hidden="true" />
                    <strong>{availableCount}</strong> {t("officialAssignmentModal.labels.available")}
                </span>
            </div>
            <div className="d-flex align-items-center mb-3 official-assignment-matchup" style={{gap: 10, maxWidth: 640, marginLeft: "auto", marginRight: "auto", width: "100%"}}>
                <TeamBadge team={homeTeam} name={homeName} alt={t("officialAssignmentModal.labels.homeLogo")} />
                <span className="official-assignment-vs rounded-circle d-flex align-items-center justify-content-center text-muted" style={{width: 30, height: 30, flex: "0 0 30px", background: "#f2f4f7", fontSize: 11, fontWeight: 900}}>VS</span>
                <TeamBadge team={visitorTeam} name={visitorName} alt={t("officialAssignmentModal.labels.awayLogo")} reverse />
            </div>
            <div className="d-flex flex-wrap mb-3 official-assignment-details" style={{gap: 8, justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                <span className="official-assignment-detail official-assignment-detail-date"><i className="far fa-calendar-alt" />{formattedDateTime(event.date, event.timezone, language)}</span>
                {location && <span className="official-assignment-detail official-assignment-detail-location"><i className="fas fa-map-marker-alt" />{location}</span>}
                {details}
            </div>
            <div className="official-assignment-picker">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="official-assignment-picker-label"><i className={`fas ${pickerIcon}`} style={{color: colors.primary}} />{pickerLabel}</div>
                    <span className="text-muted small">{selectedCount} {t("officialAssignmentModal.labels.selected")}</span>
                </div>
                {children}
                <small className="form-text text-muted mb-0">{pickerHint}</small>
            </div>
        </div>
    );
}
